/* tslint:disable */
/* eslint-disable */
/**
 * Wolf Security Portal Customer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0 (2.0)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Controller } from './Controller';
import {
    ControllerFromJSON,
    ControllerFromJSONTyped,
    ControllerToJSON,
} from './Controller';
import type { Country } from './Country';
import {
    CountryFromJSON,
    CountryFromJSONTyped,
    CountryToJSON,
} from './Country';
import type { Edition } from './Edition';
import {
    EditionFromJSON,
    EditionFromJSONTyped,
    EditionToJSON,
} from './Edition';
import type { LicenseStats } from './LicenseStats';
import {
    LicenseStatsFromJSON,
    LicenseStatsFromJSONTyped,
    LicenseStatsToJSON,
} from './LicenseStats';
import type { TenantType } from './TenantType';
import {
    TenantTypeFromJSON,
    TenantTypeFromJSONTyped,
    TenantTypeToJSON,
} from './TenantType';

/**
 * 
 * @export
 * @interface TenantDetail
 */
export interface TenantDetail {
    /**
     * 
     * @type {string}
     * @memberof TenantDetail
     */
    readonly id: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDetail
     */
    readonly shortId: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDetail
     */
    name: string;
    /**
     * 
     * @type {LicenseStats}
     * @memberof TenantDetail
     */
    readonly stats: LicenseStats;
    /**
     * 
     * @type {string}
     * @memberof TenantDetail
     */
    readonly activationCode: string;
    /**
     * 
     * @type {Controller}
     * @memberof TenantDetail
     */
    readonly controller: Controller | null;
    /**
     * 
     * @type {boolean}
     * @memberof TenantDetail
     */
    require2fa?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TenantDetail
     */
    partnerId: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantDetail
     */
    readonly partnerName: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantDetail
     */
    azureTenantId?: string | null;
    /**
     * 
     * @type {Edition}
     * @memberof TenantDetail
     */
    readonly edition: Edition | null;
    /**
     * 
     * @type {Array<Edition>}
     * @memberof TenantDetail
     */
    readonly editions: Array<Edition> | null;
    /**
     * 
     * @type {boolean}
     * @memberof TenantDetail
     */
    readonly eligibleForControllerUpgrade: boolean;
    /**
     * 
     * @type {TenantType}
     * @memberof TenantDetail
     */
    readonly tenantType: TenantType;
    /**
     * 
     * @type {boolean}
     * @memberof TenantDetail
     */
    isBusiness: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof TenantDetail
     */
    companyName?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDetail
     */
    addressLine1?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDetail
     */
    addressLine2?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDetail
     */
    addressCity?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDetail
     */
    addressCounty?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDetail
     */
    addressPostCode?: string;
    /**
     * 
     * @type {Country}
     * @memberof TenantDetail
     */
    addressCountry?: Country | null;
    /**
     * 
     * @type {string}
     * @memberof TenantDetail
     */
    contactName?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDetail
     */
    contactEmail: string;
}

/**
 * Check if a given object implements the TenantDetail interface.
 */
export function instanceOfTenantDetail(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "shortId" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "stats" in value;
    isInstance = isInstance && "activationCode" in value;
    isInstance = isInstance && "controller" in value;
    isInstance = isInstance && "partnerId" in value;
    isInstance = isInstance && "partnerName" in value;
    isInstance = isInstance && "edition" in value;
    isInstance = isInstance && "editions" in value;
    isInstance = isInstance && "eligibleForControllerUpgrade" in value;
    isInstance = isInstance && "tenantType" in value;
    isInstance = isInstance && "isBusiness" in value;
    isInstance = isInstance && "contactEmail" in value;

    return isInstance;
}

export function TenantDetailFromJSON(json: any): TenantDetail {
    return TenantDetailFromJSONTyped(json, false);
}

export function TenantDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantDetail {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'shortId': json['short_id'],
        'name': json['name'],
        'stats': LicenseStatsFromJSON(json['stats']),
        'activationCode': json['activation_code'],
        'controller': ControllerFromJSON(json['controller']),
        'require2fa': !exists(json, 'require_2fa') ? undefined : json['require_2fa'],
        'partnerId': json['partner_id'],
        'partnerName': json['partner_name'],
        'azureTenantId': !exists(json, 'azure_tenant_id') ? undefined : json['azure_tenant_id'],
        'edition': EditionFromJSON(json['edition']),
        'editions': (json['editions'] === null ? null : (json['editions'] as Array<any>).map(EditionFromJSON)),
        'eligibleForControllerUpgrade': json['eligible_for_controller_upgrade'],
        'tenantType': TenantTypeFromJSON(json['tenant_type']),
        'isBusiness': json['is_business'],
        'companyName': !exists(json, 'company_name') ? undefined : json['company_name'],
        'addressLine1': !exists(json, 'address_line_1') ? undefined : json['address_line_1'],
        'addressLine2': !exists(json, 'address_line_2') ? undefined : json['address_line_2'],
        'addressCity': !exists(json, 'address_city') ? undefined : json['address_city'],
        'addressCounty': !exists(json, 'address_county') ? undefined : json['address_county'],
        'addressPostCode': !exists(json, 'address_post_code') ? undefined : json['address_post_code'],
        'addressCountry': !exists(json, 'address_country') ? undefined : CountryFromJSON(json['address_country']),
        'contactName': !exists(json, 'contact_name') ? undefined : json['contact_name'],
        'contactEmail': json['contact_email'],
    };
}

export function TenantDetailToJSON(value?: TenantDetail | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'require_2fa': value.require2fa,
        'partner_id': value.partnerId,
        'azure_tenant_id': value.azureTenantId,
        'is_business': value.isBusiness,
        'company_name': value.companyName,
        'address_line_1': value.addressLine1,
        'address_line_2': value.addressLine2,
        'address_city': value.addressCity,
        'address_county': value.addressCounty,
        'address_post_code': value.addressPostCode,
        'address_country': CountryToJSON(value.addressCountry),
        'contact_name': value.contactName,
        'contact_email': value.contactEmail,
    };
}

